import { render, staticRenderFns } from "./custom_law.vue?vue&type=template&id=176c8f50&scoped=true&"
import script from "./custom_law.vue?vue&type=script&lang=js&"
export * from "./custom_law.vue?vue&type=script&lang=js&"
import style0 from "./custom_law.vue?vue&type=style&index=0&id=176c8f50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c8f50",
  null
  
)

export default component.exports